// useFirebase.js
// Firebase initialization and export for use in the app

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// FIX: Use REACT_APP_ prefix for Create React App
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
// console.log("FIREBASE CONFIG:", firebaseConfig);

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db };
